const $ = jQuery.noConflict();

'use strict';
const StopUploadField = {
//rename and arange the code

	classUploadField: 'upload-field-timer',

	init: function() {
		this.inputfield();
	},

	inputfield: function() {
		setTimeout(() => {
			console.log($('.ginput_container_fileupload input'));
			$('.ginput_container_fileupload button').on('change drag drop', function() {
				$(this).addClass(StopUploadField.lassUploadField);
				$('.ginput_container_fileupload input').addClass(StopUploadField.classUploadField);

				setTimeout(() => {
					$('.ginput_container_fileupload button').removeClass(StopUploadField.classUploadField);
					$('.ginput_container_fileupload input').removeClass(StopUploadField.classUploadField);
				}, 2000);
			});
			$('.ginput_container_fileupload input').on('change', function() {
				$(this).addClass(StopUploadField.lassUploadField);
				$('.ginput_container_fileupload button').addClass(StopUploadField.classUploadField);

				setTimeout(() => {
					$('.ginput_container_fileupload button').removeClass(StopUploadField.classUploadField);
					$('.ginput_container_fileupload input').removeClass(StopUploadField.classUploadField);
				}, 3000);
			});
		}, 50);
	},
};

export default StopUploadField;
